import { render } from "./ProjectHomeView.vue?vue&type=template&id=61489458&scoped=true"
import script from "./ProjectHomeView.vue?vue&type=script&lang=js"
export * from "./ProjectHomeView.vue?vue&type=script&lang=js"

import "./ProjectHomeView.vue?vue&type=style&index=0&id=61489458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61489458"]])

export default __exports__